import * as FieldConst from '../constants';

const fieldList = [
  { name: 'id' , value: FieldConst.FIELD_ID },
  { name: 'type' , value: FieldConst.FIELD_TYPE },
  { name: 'area' , value: FieldConst.FIELD_AREA },
  { name: 'created' , value: FieldConst.FIELD_CREATED },
  { name: 'created type' , value: FieldConst.FIELD_CREATED_TYPE  },
  { name: 'district' , value: FieldConst.FIELD_DISTRICT },
  { name: 'name' , value: FieldConst.FIELD_NAME },
  { name: 'updated' , value: FieldConst.FIELD_UPDATED },
];

export default fieldList;
